import { Button, Group, Modal, Text } from '@mantine/core'
import { useForm } from '@mantine/form'
import { Tradeshow } from 'api/dto/tradeshow'
import { Exhibitor } from 'api/dto/exhibitor'
import { useDeleteExhibitor } from 'api/query/exhibitor'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

interface DeleteExhibitorProps {
  opened: boolean
  onClose: () => void
  exhibitor?: Exhibitor
}

export function DeleteExhibitor({ exhibitor, opened, onClose }: DeleteExhibitorProps) {
  const { t } = useTranslation()
  const { tradeshowId } = useParams()
  const form = useForm<Tradeshow>({})
  const { mutateAsync: deleteExhibitor } = useDeleteExhibitor(tradeshowId!)
  const [submitting, setSubmitting] = useState(false)

  useEffect(() => {
    if (!opened) {
      form.reset()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [opened])

  async function onSubmit() {
    if (!exhibitor?.id) {
      return
    }

    setSubmitting(true)
    await deleteExhibitor(exhibitor.id)
    setSubmitting(false)
    onClose()
  }

  return (
    <Modal size="lg" opened={opened} onClose={onClose} title={t('exhibitor.delete')}>
      <form onSubmit={form.onSubmit(onSubmit)}>
        <Text size="15px">{t('exhibitor.delete-exhibitor', { replace: { name: exhibitor?.fullName } })}</Text>

        <Group mt={30} position="right">
          <Button disabled={submitting} variant="outline" size="xs" color="red" onClick={onClose}>
            {t('common.cancel')}
          </Button>

          <Button loading={submitting} disabled={submitting || !form.isValid()} size="xs" variant="outline" color="green" type="submit">
            {t('common.delete')}
          </Button>
        </Group>
      </form>
    </Modal>
  )
}
